<template>
  <!-- 练习 -->
  <div class="mainPage">
    <div class="practiceTrainingTask">
      <div class="backButton" @click="goBack">
        <span>
          <i class="back el-icon-arrow-left"></i>
          返回
        </span>
      </div>
      <div class="practiceTrainingTask-con" v-if="showpage">
        <div class="left">
          <div class="testPaper">
            <div class="questions">
              <ul class="cpStOption">
                <div class="subject">
                  <div class="flex-title">
                    <span class="score">{{ questionsList[topicIndex].score | grade }}分</span>
                    <h1 class="subject-title">
                      <span>{{ topicIndex + 1 }}.</span>
                      <p v-html="questionsList[topicIndex].title" class="questionstem"></p>
                    </h1>
                  </div>
                  <div class="signIcon" @click="markClick(questionsList[topicIndex])">
                    <span class="mark-btn" :class="{ active: questionsList[topicIndex].mark }"></span>
                    <span v-if="!questionsList[topicIndex].mark" class="text">标记</span>
                    <span v-else class="text">取消</span>
                  </div>
                </div>
                <div class="topicOptions">
                  <el-radio-group v-model="questionsList[topicIndex].userAnswer"
                    v-if="questionsList[topicIndex].type != 2" @change="handleClickOption(questionsList[topicIndex])">
                    <el-radio v-for="(item, index) in questionsList[topicIndex].options" :key="index"
                      :label="item.optionNumber" :disabled="!(!examine && !questionsList[topicIndex].reply)">
                      {{ item.optionNumber }}
                      <span v-html="item.optionContent"></span>
                    </el-radio>
                  </el-radio-group>
                  <el-checkbox-group v-model="userAnswerList" v-if="questionsList[topicIndex].type == 2">
                    <el-checkbox v-for="(item, index) in questionsList[topicIndex].options" :key="index"
                      :label="item.optionNumber" :disabled="!(!examine && !questionsList[topicIndex].reply)">
                      {{ item.optionNumber }}
                      <span v-html="item.optionContent"></span>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </ul>
            </div>
            <div class="btns">
              <div class="submit" :class="[questionsList[topicIndex].userAnswer ? 'answered' : '']"
                v-if="questionsList[topicIndex].type == 2 && !examine"
                @click="handleClickOption(questionsList[topicIndex])">提交答案</div>
              <div class="prev" :class="[topicIndex == 0 ? 'noClick' : '']" @click="prevQuestion">上一题</div>
              <div class="next" :class="[topicIndex == questionsList.length - 1 ? 'noClick' : '']" @click="nextQuestion">
                下一题</div>
            </div>
            <div class="analysis" v-if="!(!examine && !questionsList[topicIndex].userAnswer)">
              <div class="answer">
                <span class="correct">正确答案：{{ questionsList[topicIndex].rightAnswer }}</span>
                <span
                  :class="[questionsList[topicIndex].userAnswer == questionsList[topicIndex].rightAnswer ? 'correct' : 'respondence']">您的答案：{{
                    questionsList[topicIndex].userAnswer
                    || '未做答' }}</span>

              </div>
              <div class="analyse">
                <div class="title">答案解析</div>
                <div class="con" v-html="questionsList[topicIndex].remark || '无'"></div>
              </div>
            </div>
          </div>
        </div>
        <div :class="['right', examine ? 'examine-num' : '']">
          <div class="topCard" v-if="examine">
            <div class="scantron">
              <div class="titles">
                <svg-icon icon-class="exam-static"></svg-icon>
                练习分析
              </div>
            </div>
            <div class="chart">
              <div class="exam-results-content1">
                <!--交卷完成列表-->
                <div class="exam-results-circle">
                  <gauge :rate="examDetail.rightRate">
                    <template v-slot:txt>
                      <p class="exam-results-porgress" :style="`color:${numColor}`">
                        {{ examDetail.rightRate }}<span>%</span>
                      </p>
                      <p class="exam-num-tips1">正确率</p>
                    </template>
                  </gauge>
                </div>
                <div class="exam-results-ulbox">
                  <div class="finish">
                    <span class="dot"></span> 答对：<span class="num">{{ examDetail.rightCount }}</span>道
                  </div>
                  <div class="wrong">
                    <span class="dot"></span>答错：<span class="num">{{ examDetail.errorCount }}</span>道
                  </div>
                  <div class="none">
                    <span class="dot"></span>未答：<span class="num">{{ examDetail.emptyCount }}</span>道
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="scantron">
            <div class="titles">
              <svg-icon icon-class="datika"></svg-icon>
              答题卡
            </div>
            <div class="type">
              <span class="finish"><span></span> 答对</span>
              <span class="wrong"><span></span>答错</span>
              <span class="none"><span></span> 未答</span>
            </div>
          </div>
          <div ref="stCount" class="answer-num">
            <div v-for="(mark, index) in answerSheetList" :key="mark.id" class="list">
              <h1 v-if="mark.questionList.length > 0">
                {{
                  mark.type == 1
                  ? '单选题'
                  : mark.type == 2
                    ? '多选题'
                    : mark.type == 3
                      ? '判断题'
                      : '高阶题'
                }}
                <span> （ 共{{ mark.questionList.length }}题</span>

              </h1>
              <a v-for="(item, index1) in mark.questionList" :key="index1"
                :class="['pointer', !item.userAnswer ? 'unselected' : item.userAnswer == item.rightAnswer ? 'face' : 'error', item.questionId == active ? 'active' : '', item.mark ? 'question-mark' : '']"
                @click.prevent="anchor(item.questionId)">
                <span v-if="index == 1">
                  {{
                    answerSheetList[index - 1].questionList.length + index1 + 1
                  }}
                </span>
                <span v-else-if="index == 2">
                  {{
                    answerSheetList[index - 2].questionList.length +
                    answerSheetList[index - 1].questionList.length +
                    index1 +
                    1
                  }}
                </span>
                <span v-else-if="index == 3">
                  {{
                    answerSheetList[index - 3].questionList.length +
                    answerSheetList[index - 2].questionList.length +
                    answerSheetList[index - 1].questionList.length +
                    index1 +
                    1
                  }}
                </span>
                <span v-else>{{ index1 + 1 }}</span>
              </a>
            </div>
          </div>
          <div class="answer-btn" v-if="isShowSubmit">
            <div class="btn" @click="submitExam">马上交卷</div>
          </div>

        </div>
      </div>
    </div>
    <el-dialog class="tip-dialog" :visible.sync="coursedialogVisible" width="400px" :before-close="handleClose">
      <svg-icon class="icon-img" icon-class="tips"></svg-icon>
      <p class="titles">提示</p>
      <p class="text" v-if="complete"> 是否要进行交卷？</p>
      <p class="text" v-else>
        您还有<span>{{ remainingNum }}</span> 道题目未作答，确认交卷？
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="!complete" @click="leftBtn()">{{ cancelText }}</el-button>
        <el-button type="primary" @click="rightBtn()">{{
          submitText
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import gauge from './gauge.vue'
export default {
  name: "practiceTrainingTask",
  show: true,
  components: {
    gauge
  },
  data() {
    return {
      showpage: false,
      coursedialogVisible: false,
      cancelText: "",
      submitText: "",
      remainingNum: null,
      complete: false,
      examDetail: {},
      stList: 0,
      questionsList: [], // 题目列表
      answerSheetList: [], // 答题卡列表
      saveData: {
        userPaperId: "", // 试卷id
        commitTime: "", // 提交时间
      },
      userPracticeId: this.$route.query.userPracticeId,
      practiceId: this.$route.query.practiceId,
      businessId: this.$route.query.businessId,
      businessType: this.$route.query.businessType,
      practiceModel: this.$route.query.practiceModel,
      sequence: Number(this.$route.query.sequence),// 上次答题最后一题的序号
      practiceShow: this.$route.query.practiceShow, // true 查看 false 答题
      topicIndex: null,
      cacheTopicIndex: null,
      numColor: '',
      active: null,
      userPaperCommitDto: {}, // 单次提交接口参数
      userAnswerList: [],
      questionSwitch: false,
      cacheQuestionsList: [], // 题目缓存
      cacheAnswerSheetList: [], // 答题卡缓存
      examine: false,
      examParams: {},// 上个页面的参数
      isShowSubmit: false, // 是否显示交卷 错题 标记 不显示
    };
  },
  filters: {
    grade(msg) {
      if (msg % 1 === 0) {
        return msg + '.0'
      } else {
        return msg.toFixed(1)
      }
    },
  },
  destroyed() {
    sessionStorage.removeItem("questionsList");
    sessionStorage.removeItem("answerSheetList");
    sessionStorage.removeItem("topicIndex");
  },
  mounted() {
    this.cacheQuestionsList = JSON.parse(sessionStorage.getItem("questionsList"))
    this.cacheAnswerSheetList = JSON.parse(sessionStorage.getItem("answerSheetList"))
    this.cacheTopicIndex = JSON.parse(sessionStorage.getItem("topicIndex"))
  },
  async created() {
    this.examParams = { ...this.$route.query };
    if ((this.examParams.type == 1) || (this.examParams.type == 2)) {
      this.isShowSubmit = true;
    }
    if (this.practiceShow) {
      // 查看
      this.findUserPaperInfo();
      this.examine = true;
    } else {
      // 答题
      await this.findQuestForExam();
      this.examine = false;
    }
    this.returnButton();
  },
  methods: {
    // 只看错题
    changeSwitch(val) {
      if (val) {
        var have = this.questionsList.some((ele) => {
          if (ele.userAnswer != ele.rightAnswer) {
            return true;
          }
        })
        if (have) {
          for (var i = 0; i < this.questionsList.length; i++) {
            if (this.questionsList[i].userAnswer != this.questionsList[i].rightAnswer) {
              this.topicIndex = i;
              this.assignment();
              return;
            }
          }
        } else {
          this.questionSwitch = false;
          this.$message({
            message: '全部作答正确，无答错、未答',
            type: 'warning'
          });
        }
      } else {
        this.topicIndex = 0;
        this.assignment();
      }
    },
    // 点击标记
    markClick(question) {
      const question1 = question;
      this.$nextTick(() => {
        question1.mark = !question1.mark;
        this.questionMark();
      });

    },
    assignment() {
      this.active = this.questionsList[this.topicIndex].questionId;
      this.userAnswerList = this.questionsList[this.topicIndex].userAnswer ? this.questionsList[this.topicIndex].userAnswer.split(',') : [];
    },
    // 下一题
    nextQuestion() {
      if (this.topicIndex < this.questionsList.length - 1) {
        if (this.questionSwitch) {
          var newQuestionsList = this.questionsList.slice(this.topicIndex + 1, this.questionsList.length);
          var have = newQuestionsList.some((ele) => {
            if (ele.userAnswer != ele.rightAnswer) {
              return true;
            }
          })
          if (have) {
            for (var i = this.topicIndex + 1; i < this.questionsList.length; i++) {
              if (this.questionsList[i].userAnswer != this.questionsList[i].rightAnswer) {
                this.topicIndex = i;
                this.assignment();
                return;
              }
            }
          } else {
            this.$message({
              message: '暂无错题、未答题',
              type: 'warning'
            });
          }
        } else {
          this.topicIndex++;
          this.assignment();
        }
        sessionStorage.setItem("topicIndex", JSON.stringify(this.topicIndex));
      } else {
        if (this.questionSwitch) {
          this.$message({
            message: '暂无错题、未答题',
            type: 'warning'
          });
        }
      }
    },
    // 上一题
    prevQuestion() {
      if (this.topicIndex > 0) {
        if (this.questionSwitch) {
          var newQuestionsList = this.questionsList.slice(0, this.topicIndex);
          var have = newQuestionsList.some((ele) => {
            if (ele.userAnswer != ele.rightAnswer) {
              return true;
            }
          })
          if (have) {
            for (var i = this.topicIndex - 1; i >= 0; i--) {
              if (this.questionsList[i].userAnswer != this.questionsList[i].rightAnswer) {
                this.topicIndex = i;
                this.assignment();
                return;
              }
            }
          } else {
            this.$message({
              message: '暂无错题、未答题',
              type: 'warning'
            });
          }
        } else {
          this.topicIndex--;
          this.assignment();
        }
        sessionStorage.setItem("topicIndex", JSON.stringify(this.topicIndex));
      } else {
        if (this.questionSwitch) {
          this.$message({
            message: '暂无错题、未答题',
            type: 'warning'
          });
        }
      }
    },
    // 单次提交答案
    commitPaper() {
      this.getASingleAnswer();
      if ((this.examParams.type == 1 || this.examParams.type == 2)) {
        this.$api.practice.commitPaper(this.userPaperCommitDto).then(data => {
          console.log('data', data)
          sessionStorage.setItem("topicIndex", JSON.stringify(this.topicIndex));
          sessionStorage.setItem("questionsList", JSON.stringify(this.questionsList));
          sessionStorage.setItem("answerSheetList", JSON.stringify(this.answerSheetList));
          if (this.questionsList[this.topicIndex].userAnswer == this.questionsList[this.topicIndex].rightAnswer) {
            this.nextQuestion();
          }
        })
      } else {
        console.log('是否错误 0 正确，1 错误。练习使用是否错误 0 正确，1 错误。练习使用')
        let error = ''
        //error   是否错误 0 正确，1 错误。练习使用
        if (this.questionsList[this.topicIndex].userAnswer == this.questionsList[this.topicIndex].rightAnswer) {
          error = 0
        } else {
          error = 1
        }
        let dicData = {
          practiceId: this.examParams.practiceId,
          questionId: this.questionsList[this.topicIndex].questionId,
          businessId: this.examParams.businessId,
          businessType: 3,
          mark: this.questionsList[this.topicIndex].mark ? 1 : 0,
          error:error

        }
        let data =dicData;

        this.$api.practice.questionMark(data, dicData).then(data => {
          console.log('data', data)
          sessionStorage.setItem("topicIndex", JSON.stringify(this.topicIndex));
          sessionStorage.setItem("questionsList", JSON.stringify(this.questionsList));
          sessionStorage.setItem("answerSheetList", JSON.stringify(this.answerSheetList));
          if (this.questionsList[this.topicIndex].userAnswer == this.questionsList[this.topicIndex].rightAnswer) {
            this.nextQuestion();
          }
        })
      }

    },
    // 标记接口
    questionMark() {
      this.getASingleAnswer();
      if ((this.examParams.type == 1 || this.examParams.type == 2)) {
        this.$api.practice.commitPaper(this.userPaperCommitDto).then(data => {
          console.log(data, '标记')
        })
      } else {
        console.log(this.userPaperCommitDto, 'this.userPaperCommitDtothis.userPaperCommitDto')
        let dicData = {
          practiceId: this.examParams.practiceId,
          questionId: this.questionsList[this.topicIndex].questionId,
          businessId: this.examParams.businessId,
          businessType: 3,
          mark: this.questionsList[this.topicIndex].mark ? 1 : 0,
        }
        let data = dicData;
        this.$api.practice.questionMark(data, dicData).then(data => {
          console.log(data, '标记')
        })
      }



    },
    getASingleAnswer() {
      // const that = this;
      this.userPaperCommitDto = {};
      this.userPaperCommitDto.commitTime = this.dateFormat();
      this.userPaperCommitDto.userPaperId = this.examDetail.userPracticeId;
      console.log(this.questionsList[this.topicIndex], 'his.questionsList[this.topicIndex]')

      let error = ''
      //error   是否错误 0 正确，1 错误。练习使用
      if (this.questionsList[this.topicIndex].userAnswer == this.questionsList[this.topicIndex].rightAnswer) {
        error = 0
      } else {
        error = 1
      }
      this.userPaperCommitDto.answerList = [{
        error: error,
        answer: this.questionsList[this.topicIndex].userAnswer,
        mark: this.questionsList[this.topicIndex].mark ? 1 : 0,
        questionId: this.questionsList[this.topicIndex].questionId,
        questionType: this.questionsList[this.topicIndex].type,
      }]
    },
    // 单选 判断
    handleClickOption(question) {
      this.$nextTick(() => {
        if (!question.reply) {
          let userAnswer = '';
          // 试题类型 0:实操;1:单选,2:多选,3:判断,4:高阶,5问答题,6填空,7组合题
          if (question.type == 2) {
            if (this.userAnswerList.length) {
              userAnswer = this.userAnswerList.sort().join(',');
            } else {
              userAnswer = '';
            }
          } else {
            userAnswer = this.questionsList[this.topicIndex].userAnswer;
          }
          if (userAnswer) {
            this.questionsList.forEach(ele => {
              if (ele.questionId == question.questionId) {
                ele.userAnswer = userAnswer;
                ele.reply = true;
              }
            })
            this.answerSheetList.forEach(ele => {
              ele.questionList.forEach(item => {
                if (item.questionId == question.questionId) {
                  item.userAnswer = userAnswer;
                  item.reply = true;
                }
              })
            })
            
            this.commitPaper()
          } else {
            this.$message({
              message: '请选择',
              type: 'warning'
            });
          }
        }
      })
    },
    // 获取题目
    async findQuestForExam() {
      let params = {
        businessId: this.examParams.businessId,
        businessType: this.examParams.businessType,
        practiceId: this.examParams.practiceId,
        businessName: this.examParams.businessName,
        type: this.examParams.type,
        userPracticeId: this.examParams.userPracticeId,
        channel: 2,
        channelType: 3,
      }
      let data = params;
      let res = await this.$api.practice.userPracticejoinExamJJ({ data, params })
      if (res.data) {
        this.examDetail = res.data;
        this.userPracticeId = res.data.userPracticeId;
        if (!this.cacheQuestionsList) {
          this.questionsList = res.data.questions;
          // 拿到上次答题的题号
          let questionItem = ''
          let questionIndex = 0
          questionItem = this.questionsList.find(function (elem) {
            return elem.questionId == res.data.lastQuestionId;
          });
          questionIndex = questionItem !== undefined ? this.questionsList.indexOf(questionItem) : 0
          this.sequence = questionIndex;
          this.formatting(this.questionsList);
        } else {
          this.topicIndex = Number(this.cacheTopicIndex);
          this.questionsList = this.cacheQuestionsList;
          this.answerSheetList = this.cacheAnswerSheetList;
          if (this.questionsList.length > 0) {
            this.showpage = true;
          }
        }
      }

    },
    // 查看
    findUserPaperInfo() {
      this.$api.practice.findUserPaperInfo(this.userPracticeId).then((res) => {
        if (res.data) {
          this.examDetail = res.data;
          this.questionsList = this.examDetail.examQuestionInfos;
          this.formatting(this.questionsList);
          this.examDetail.rightRate = Number(this.examDetail.rightRate);
          if (this.examDetail.rightRate >= 50) {
            this.numColor = '#415FF6';
          } else {
            this.numColor = '#FFA132';
          }
        }
      });
    },
    formatting(data) {
      if (data.length > 0) {
        this.showpage = true;
        if (this.sequence) {
          if (this.sequence < data.length) {
            this.topicIndex = this.sequence;
          } else {
            this.topicIndex = this.sequence - 1;
          }
        } else {
          this.topicIndex = 0;
        }
        if (data[this.topicIndex].type == 2) {
          this.userAnswerList = data[this.topicIndex].userAnswer ? data[this.topicIndex].userAnswer.split(',') : [];
        }
        this.active = data[this.topicIndex].questionId;
        var subjectList = [];
        if (this.practiceShow) {
          this.stList = this.examDetail.examQuestionInfos.length;
          subjectList = this.examDetail.examQuestionInfos;
        } else {
          this.stList = this.examDetail.questions.length;
          subjectList = this.examDetail.questions;
        }
        this.answerSheetList = [];
        subjectList.forEach((item) => {
          if (this.answerSheetList.length == 0) {
            this.answerSheetList.push({
              totalMark: '',
              type: item.type,
              questionList: [
                item
              ]
            })
          } else {
            var have = this.answerSheetList.some((ele) => {
              if (ele.type == item.type) {
                return true;
              }
            })
            if (have) {
              this.answerSheetList.forEach((ele, index1) => {
                if (ele.type == item.type) {
                  this.answerSheetList[index1].questionList.push(item);
                }
              })
            } else {
              this.answerSheetList.push({
                totalMark: '',
                type: item.type,
                questionList: [
                  item
                ]
              })
            }
          }
        })
      }
    },
    // 点击题号锚点
    anchor(anchorName) {
      this.active = anchorName;
      this.questionsList.forEach((ele, index) => {
        if (ele.questionId == anchorName && anchorName != this.questionsList[this.topicIndex].questionId) {
          this.topicIndex = index;
          sessionStorage.setItem("topicIndex", JSON.stringify(this.topicIndex));
          this.userAnswerList = this.questionsList[this.topicIndex].userAnswer ? this.questionsList[this.topicIndex].userAnswer.split(',') : [];
        }
      })
    },
    // 浏览器回退按钮到训练营
    returnButton() {
      // if (this.$route.name == "practiceTrainingTask") {
      //   let that = this;
      //   if (window.history && window.history.pushState) {
      //     window.onpopstate = function () {
      //       window.history.pushState('forward', null, '#');
      //       window.history.forward(1);
      //       that.goBack();
      //     }
      //   }
      //   window.history.pushState('forward', null, '#'); //在IE中必须得有这两行
      //   window.history.forward(1);
      // }
    },
    // 返回
    goBack() {
      this.$router.back();
      // this.$router.push({
      //   path: "/pattern",
      //   query: {
      //     businessId: this.businessId,
      //     practiceId: this.practiceId,
      //     businessType: this.businessType,
      //     backPath: this.$route.query.backPath,
      //     backModule: this.$route.query.backModule,
      //   },
      // });
    },
    leftBtn() {
      // if (this.complete) {
      //   this.handleClose();
      // } else {
      //   this.commitAllPaper();
      // }
      this.handleClose();

      // this.commitAllPaper();

    },
    rightBtn() {
      // if (this.complete) {
      //   this.commitAllPaper();
      // } else {
      //   this.handleClose();
      // }
      this.commitAllPaper();

    },
    // 提交
    submitExam() {
      let num = 0;
      this.questionsList.forEach((val) => {
        if (val.reply) {
          num += 1;
        }
      });
      this.coursedialogVisible = true;
      if (num === Number(this.examDetail.questions.length)) {
        this.complete = true;
        this.cancelText = '继续答题';
        this.submitText = '提交';
      } else {
        this.complete = false;
        this.remainingNum = Number(this.examDetail.questions.length) - num;
        this.cancelText = '继续答题';
        this.submitText = '提交';
      }
    },
    // 关闭弹框
    handleClose() {
      this.coursedialogVisible = false;
    },
    // 提交练习
    commitAllPaper() {
      console.log('提交++++++')
      // this.getPaperList();
      let queryData = {
        type: this.examParams.type
      }

      let data = {}
      data.commitTime = this.dateFormat();
      data.userPaperId = this.examDetail.userPracticeId;
      data.answerList = []
      this.$api.practice.commitAllPaper(data, queryData).then((res) => {
        if (res.data) {
          this.coursedialogVisible = false;
          this.$router.push({
            path: "/practiceResult",
            query: {
              businessId: this.businessId,
              businessType: this.businessType,
              practiceId: this.practiceId,
              practiceModel: this.practiceModel,
              userPracticeId: this.examDetail.userPracticeId,
              backPath: this.$route.query.backPath,
              backModule: this.$route.query.backModule,
              type: this.examParams.type
            },
          });
        }
      });
    },
    // 试卷信息
    // getPaperList() {
    // this.saveData.commitTime = this.dateFormat();
    // this.saveData.answerList = [];
    // this.saveData.practiceId = this.userPracticeId;
    // this.questionsList.forEach((item) => {
    //   const item1 = item;
    //   if (item1.userAnswer && item1.userAnswer.length > 1) {
    //     let userAnswer = item1.userAnswer.split(",");
    //     item1.userAnswer = Array.from(userAnswer).sort().join(",");
    //   }
    //   if (item1.userAnswer !== undefined) {
    //     this.saveData.answerList.push({
    //       answer: item1.userAnswer,
    //       mark: item1.mark,
    //       questionId: item1.questionId,
    //       questionType: item1.type,
    //     });
    //   }
    // });
    // },
    // 时间转换
    dateFormat() {
      const date = new Date();
      const year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      const month =
        date.getMonth() + 1 < 10
          ? `0${date.getMonth() + 1}`
          : date.getMonth() + 1;
      const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      const hours =
        date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
      const minutes =
        date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
      const seconds =
        date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
      // 拼接
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>
<style lang="scss" src="../css/practiceTrainingTask.scss" scoped></style>
